import { setToken, setAccountId } from '@/utils/auth'

// 用来判断是安卓设备还是IOS设备
export function getPlatform() {
  var u = navigator.userAgent
  var ua = navigator.userAgent.toLowerCase()
  if (u.indexOf('guider-ios') > -1) { // ios
    return 'ios'
  } else if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return 'weixin'
  } else if (u.indexOf('guider-android') > -1) {
    console.log('anzuo')
    return 'android'
  } else {
    return 'web'
  }
}

export const autoAppLogin = new Promise(function(resolve, reject) {
  if (getPlatform() === 'web' || getPlatform() === 'weixin') {
    resolve()
    return false
  } else if (getPlatform() === 'ios') {
    console.log('ios---')
    window.setUserInfo = function(data) {
      const { token, accountId } = data
      setToken(token)
      setAccountId(accountId)
      resolve(token)
    }
    window.webkit.messageHandlers.getUserInfo.postMessage({ 'callback': 'setUserInfo' })
  } else if (getPlatform() === 'android') {
    window.setUserInfoLogin = function(data) {
      const { token, accountId } = data
      setToken(token)
      setAccountId(accountId)
      resolve(token)
    }
    window.Android.getUserInfo('setUserInfoLogin')
  }
})
